module.exports = __webpack_public_path__ + "static/img/jinzhou.d7adba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/jinzhou.png
// module id = Tk8x
// module chunks = 93